import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { convertLeadTimeToDays } from '@/coreDomainsModule/leadtime';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { AggregateBusinessPutRequest } from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 集計取引を編集する
 */
export class PutAggregateBusinessUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 既存の集計取引を編集する
   * @param aggregateBusiness - 編集する集計情報
   */
  public async execute(aggregateBusiness: IBusiness): Promise<INetworkResult<void, Error>> {
    const request: AggregateBusinessPutRequest = {
      putAggregateBusinessRequestInfo: {
        aggregateBusinessId: aggregateBusiness.businessId,
        warehouse: aggregateBusiness.warehouse,
        warehouseNumber: aggregateBusiness.warehouseNumber,
        supplierName: aggregateBusiness.supplierName,
        supplierNumber: aggregateBusiness.supplierNumber,
        businessName: aggregateBusiness.businessName ?? '',
        businessNumber: aggregateBusiness.businessNumber,
        package: aggregateBusiness.package.toString(),
        unit: aggregateBusiness.unit ?? '',
        manufacturer: aggregateBusiness.manufacturer,
        stdInventoryIndicesMin: (aggregateBusiness.stdInventoryIndices?.標準在庫指数?.min || 0).toString(),
        stdInventoryIndicesMax: (aggregateBusiness.stdInventoryIndices?.標準在庫指数?.max || 0).toString(),
        stdInventoryIndicesUnit: aggregateBusiness.stdInventoryIndices?.標準在庫指数?.option?.unit || '',
        leadTime: (aggregateBusiness.leadTime || 0).toString(),
        leadTimeUnit: aggregateBusiness.leadTimeUnit ?? '',
        inTransitDays: aggregateBusiness.inTransitDays ?? 0,
        moq: aggregateBusiness.MOQ?.toString(),
        orderPackage: aggregateBusiness.orderPackage?.toString(),
        purchaseUnitPrice: aggregateBusiness.purchaseUnitPrice?.toString(),
        userUniqueNumber: aggregateBusiness.userUniqueNumber,
        aggregateBusinessResponsibleUserIdList:
          aggregateBusiness.aggregateBusinessResponsibleUsers?.map((user) => user.email).filter((userId) => userId !== undefined) ?? [],
        businessFreeColumnValues: aggregateBusiness.businessFreeColumnValues
          ?.filter((column) => column.isConfigured)
          .map((column) => ({
            columnNo: column.columnNo,
            value: column.value,
          })),
      },
    };
    try {
      const response = await this.repository.put(request);

      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: Error('集計情報の編集に失敗しました'),
          },
        };
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('集計情報の編集に失敗しました'),
        },
      };
    }
  }
}
